var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashtaglarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84.4c.52.11.84.62.73 1.14L5.83 22.87a.96.96 0 1 1-1.88-.41L8.7 1.13A.96.96 0 0 1 9.84.4ZM19.33.4c.51.11.84.62.73 1.14L15.3 22.87a.96.96 0 1 1-1.87-.41l4.74-21.33A.96.96 0 0 1 19.33.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.56 7.26c0-.53.43-.96.96-.96h20.15a.96.96 0 1 1 0 1.92H2.52a.96.96 0 0 1-.96-.96ZM.37 16.74c0-.53.43-.96.96-.96h20.15a.96.96 0 1 1 0 1.92H1.33a.96.96 0 0 1-.96-.96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtaglarge);
export default __webpack_public_path__ + "static/media/hashtag.large.f4be8a0e76fa008ac6587826cc22b255.svg";
export { ForwardRef as ReactComponent };